var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"value":_vm.value,"resource":"networks","params":_vm.params,"need-params":"","filterable":""},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }